const getDotProps = (startPos: number, endPos: number, dotsCount: number, dotMaxRadius: number) => (currentDot: number): {
    position: number,
    radius: number,
} => {
    // radius ratio, 8 max between 1 min. you could see design pattern ;-)
    const dotMinRadius = dotMaxRadius / 8;
    // difference between the max and min radius
    const radiusDiff = dotMaxRadius - dotMinRadius;
    const width = Math.abs(endPos - startPos);
    const part = width / (dotsCount - 1);
    const position = part * currentDot + startPos;

    return {
        position: position,
        radius: radiusDiff * (position / width) + dotMinRadius,
    };
};

export default getDotProps;
